var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "b-field",
            { attrs: { label: _vm.$t("pages.plants.forecast.range_date") } },
            [
              _c("b-datepicker", {
                attrs: {
                  inline: "",
                  "min-date": new Date(_vm.$dayjs().subtract("1", "day")),
                  placeholder: "Click to select...",
                  range: "",
                },
                model: {
                  value: _vm.editionParams.rangeDates,
                  callback: function ($$v) {
                    _vm.$set(_vm.editionParams, "rangeDates", $$v)
                  },
                  expression: "editionParams.rangeDates",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "b-field",
            { attrs: { label: _vm.$t("pages.plants.forecast.working_days") } },
            [
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.allowSaturday,
                    callback: function ($$v) {
                      _vm.allowSaturday = $$v
                    },
                    expression: "allowSaturday",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.saturday")) + " ")]
              ),
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.allowSunday,
                    callback: function ($$v) {
                      _vm.allowSunday = $$v
                    },
                    expression: "allowSunday",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.sunday")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "b-field",
            [
              _c(
                "b-select",
                {
                  attrs: { placeholder: _vm.$t("global.material") },
                  model: {
                    value: _vm.editionParams.material,
                    callback: function ($$v) {
                      _vm.$set(_vm.editionParams, "material", $$v)
                    },
                    expression: "editionParams.material",
                  },
                },
                _vm._l(_vm.materials, function (option) {
                  return _c(
                    "option",
                    { key: option, domProps: { value: option } },
                    [_vm._v(" " + _vm._s(option) + " ")]
                  )
                }),
                0
              ),
              _c(
                "b-select",
                {
                  attrs: { placeholder: _vm.$t("global.operation") },
                  model: {
                    value: _vm.editionParams.operation,
                    callback: function ($$v) {
                      _vm.$set(_vm.editionParams, "operation", $$v)
                    },
                    expression: "editionParams.operation",
                  },
                },
                _vm._l(
                  _vm.operations.filter((e) => e.type === "operation"),
                  function (option) {
                    return _c(
                      "option",
                      {
                        key: option.operation,
                        domProps: { value: option.operation },
                      },
                      [_vm._v(" " + _vm._s(option.operation) + " ")]
                    )
                  }
                ),
                0
              ),
            ],
            1
          ),
          _c(
            "b-field",
            [
              _c("b-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.editionParams.quantity,
                  callback: function ($$v) {
                    _vm.$set(_vm.editionParams, "quantity", $$v)
                  },
                  expression: "editionParams.quantity",
                },
              }),
              _c(
                "p",
                { staticClass: "control" },
                [
                  _c("b-button", {
                    attrs: {
                      type: "is-info",
                      label: _vm.$t("global.edit"),
                      "icon-left": "edit",
                      disabled:
                        !_vm.editionParams.material ||
                        !_vm.editionParams.operation ||
                        _vm.editionParams.quantity === "0",
                    },
                    on: { click: _vm.updateOperations },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }